// extracted by mini-css-extract-plugin
module.exports = {"category_chart":"ProductCategoryStats_category_chart__3igyW","category_chart_title":"ProductCategoryStats_category_chart_title__3rt9k"};